import { API_ENDPOINTS } from "../config/api.js";
import { makeApiRequest } from "./apiClient.js";

export const notificationService = {
  getUnreadNotifications: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.GET_NOTIFICATION}?afterId=0`, // ✅ afterId=0 gets all unread
        method: "GET",
        accessToken: localStorage.getItem("accessToken"),
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching notifications:", error);
      throw error;
    }
  },

  markAsRead: async ({ ids }) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.MARK_AS_READ,
        method: "POST",
        data: ids, // ✅ plain array [1194, 3634]
        accessToken: localStorage.getItem("accessToken"),
      });
      return response.data;
    } catch (error) {
      console.error("Error marking notification as read:", error);
      throw error;
    }
  },
};
